// src/components/KpiCard.js
import React from "react";

export default function KpiCard({
  title,
  value,
  hint,
  icon: Icon,
  onClick,
  loading = false,
}) {
  return (
    <button
      type={onClick ? "button" : "button"}
      onClick={onClick}
      className="w-full text-left rounded-2xl border border-gray-200 bg-white p-5 shadow-sm hover:shadow transition"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm text-gray-500">{title}</div>
          <div className="mt-1 text-2xl font-semibold tabular-nums">
            {loading ? "—" : value}
          </div>
          {hint ? <div className="mt-1 text-xs text-gray-400">{hint}</div> : null}
        </div>
        {Icon ? <Icon className="h-6 w-6 opacity-70" /> : null}
      </div>
    </button>
  );
}
